module.exports = __webpack_public_path__ + "static/media/Graphic3.af6c0df4.png";